import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IItemForGetShortInfo } from 'types';
import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';

interface IProps {
	fetchedRestaurants: IItemForGetShortInfo[];
}

export const RestaurantSelect: React.FC<IProps> = React.memo(({ fetchedRestaurants }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectRestaurant') }], [t]);

	return (
		<FormSelect
			testId="RestaurantSelect"
			name="IDSelectedRestaurant"
			label="restaurantLabel"
			options={fetchedRestaurants}
			validationRules={validationRules}
			disabled={true}
		/>
	);
});
